import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpService} from './http.service';
import {APIResponse, PagingResponse, PresignedURL} from '@core/interfaces/system/system-common';
import {
    Document,
    DocumentAssetImage,
    DocumentCreate,
    DocumentDto,
    EnginDocumentType,
} from '@core/interfaces/common/document';
import {HttpParams} from '@angular/common/http';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {map} from 'rxjs/operators';

@Injectable()
export class DocumentApi {
    private readonly prefix = 'document';

    constructor(private api: HttpService) {}

    listFiles(assetId: string): Observable<DataSource> {
        return this.api.getServerDataSource(`${this.prefix}/list?filterByrelatedEntity_EQUAL=${assetId}`);
    }

    /*
     * Operations
     */
    create(document: DocumentCreate): Observable<APIResponse<Document>> {
        return this.api.post(`${this.prefix}/`, document);
    }

    update(documentId: number, document: any): Observable<APIResponse<Document>> {
        return this.api.put(`${this.prefix}/${documentId}`, document);
    }

    delete(documentId: number): Observable<APIResponse<boolean>> {
        return this.api.delete(`${this.prefix}/${documentId}`, {});
    }

    getPresignedUrl(fileName: string, fileFormat: string): Observable<APIResponse<PresignedURL>> {
        return this.api.get(`${this.prefix}/presigned-url`, {
            params: new HttpParams().set('fileName', fileName).set('fileFormat', fileFormat),
        });
    }

    upload(url: string, fileData: File): Observable<any> {
        return this.api.uploadS3(`${url}`, fileData, {
            reportProgress: true,
            observe: 'events',
            headers: {
                'Content-Disposition': 'attachment',
                'Content-Type': fileData.type,
            },
        });
    }

    /*
     * Retrieval
     */
    getAssetImageDocuments(assetId: string): Observable<APIResponse<DocumentAssetImage[]>> {
        const type: string = EnginDocumentType.ASSET;
        return this.api.get(`${this.prefix}/type/${type}/asset/${assetId}`);
    }

    getDocumentListWithUrls(paramsString: string = ''): Observable<PagingResponse<DocumentDto>> {
        return this.api.get(`${this.prefix}/list-with-urls${paramsString && '?' + paramsString}`);
    }
    findOne(documentId: string): Observable<APIResponse<Document>> {
        return this.api.get(`${this.prefix}/${documentId}`);
    }

    getSearchTag(searchTag: string = ''): Observable<string[]> {
        return this.api
            .get(`${this.prefix}/tag-list`, {
                params: new HttpParams().set('searchTag', searchTag),
            })
            .pipe(map((res: APIResponse<string[]>) => res.response));
    }
    getAllTags(assetId: string): Observable<APIResponse<string[]>> {
        return this.api.get(`${this.prefix}/tags/${assetId}`);
    }
}
